import React, { useEffect } from "react";
import { IPaginationProps } from "components/Pagination/Pagination.interface";
import {
  PaginationContainer,
  PaginationItem,
  PaginationLink,
  PaginationList,
} from "components/Pagination/Pagination.styled";

const Pagination = (props: IPaginationProps) => {
  useEffect(() => {}, [props.pagination.page]);

  const totalPages = Math.ceil(props.pagination.total / props.pagination.limit);

  return (
    <PaginationContainer
      className={`pagination-container flex-column flex-sm-row a11y-fonts-flex-column a11y-fonts-flex-lg-row ${props.className}`}
    >
      <PaginationList className="pagination justify-content-center">
        {props.pagination.page > 1 && (
          <>
            <PaginationItem className="page-item">
              <PaginationLink
                className="page-link"
                data-testid="first-page-button"
                onClick={() => props.setData(1)}
                type="button"
                tabIndex={0}
              >
                {"<<"}
              </PaginationLink>
            </PaginationItem>
            <PaginationItem className="page-item">
              <PaginationLink
                className="page-link"
                data-testid="previous-page-button"
                onClick={() => props.setData(props.pagination.page - 1)}
                type="button"
                tabIndex={0}
              >
                {"<"}
              </PaginationLink>
            </PaginationItem>
          </>
        )}
        {props.pagination.page > 1 && (
          <PaginationItem
            className={`page-item ${
              props.pagination.page - 1 === props.pagination.page
                ? "active"
                : ""
            }`}
          >
            <PaginationLink
              className="page-link"
              onClick={() => props.setData(props.pagination.page - 1)}
              tabIndex={0}
            >
              {props.pagination.page - 1}
            </PaginationLink>
          </PaginationItem>
        )}
        <PaginationItem className="page-item active">
          <PaginationLink className="page-link">
            {props.pagination.page}
          </PaginationLink>
        </PaginationItem>
        {props.pagination.page < totalPages && (
          <PaginationItem
            className={`page-item ${
              props.pagination.page + 1 === props.pagination.page
                ? "active"
                : ""
            }`}
          >
            <PaginationLink
              className="page-link"
              onClick={() => props.setData(props.pagination.page + 1)}
              tabIndex={0}
            >
              {props.pagination.page + 1}
            </PaginationLink>
          </PaginationItem>
        )}
        {props.pagination.page < totalPages && (
          <PaginationItem className="page-item">
            <PaginationLink
              className="page-link"
              data-testid="next-page-button"
              onClick={() => props.setData(props.pagination.page + 1)}
              tabIndex={0}
            >
              {">"}
            </PaginationLink>
          </PaginationItem>
        )}
        {props.pagination.page < totalPages && (
          <PaginationItem className="page-item">
            <PaginationLink
              className="page-link"
              data-testid="last-page-button"
              onClick={() => props.setData(totalPages)}
              tabIndex={0}
            >
              {">>"}
            </PaginationLink>
          </PaginationItem>
        )}
      </PaginationList>
    </PaginationContainer>
  );
};

export default Pagination;
